import React from "react";
import {
  Box,
  Flex,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  useDisclosure,
} from "@chakra-ui/react";
import { Outlet } from "react-router-dom";
import Sidebar from "../../components/admin/Sidebar";
import Header from "../../components/admin/Header";
import ChatWidget from "../../components/chat/ChatWidget";
import AdminOpsChatDock from "../../components/admin/opsChat/AdminOpsChatDock";
import { AdminFeatureNoticeProvider } from "../../components/admin/featureNotice/AdminFeatureNoticeContext";

const AdminLayout = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <AdminFeatureNoticeProvider>
    <Box className="admin-selection">
      <Header onSidebarOpen={onOpen} />
      <Flex pt="60px">
        <Sidebar />
        <Box
          flex="1"
          p={{ base: 4, md: 8 }}
          bg="neutral.50"
          minH="calc(100vh - 60px)"
          className="admin-scroll"
          overflowY="auto"
          overflowX="auto"
        >
          <Outlet />
        </Box>
      </Flex>

      {/* Mobile sidebar drawer */}
      <Drawer isOpen={isOpen} placement="left" onClose={onClose}>
        <DrawerOverlay />
        <DrawerContent bg="neutral.900" maxW="280px" overflowY="auto">
          <DrawerCloseButton color="neutral.400" zIndex={1} />
          <Sidebar isMobile onClose={onClose} />
        </DrawerContent>
      </Drawer>

      <ChatWidget />
      {/* 운영팀 대화방 — 어드민 어디서나 오른쪽 아래 (2026-11-03) */}
      <AdminOpsChatDock />
    </Box>
    </AdminFeatureNoticeProvider>
  );
};

export default AdminLayout;
